<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="7">
          <v-sheet class="neu-glow with-radius">
            <v-card-text class="pa-0">
              <v-row class="ma-0">                
                <v-col cols="12" md="12">
                  <div class="my-8 text-center">
                    <div class="text-h4">Create Account</div>
                  </div>
                  <v-sheet max-width="380" class="mx-auto" color="transparent">
                    <v-form
                      @submit.prevent="
                        $v.$invalid || !form.agreeToPolicy ? null : submit()
                      "
                      ref="form"
                    >
                      <alert-message></alert-message>
                      <v-text-field
                        label="User Name"
                        v-model="form.userName"
                        :error-messages="
                          [].concat(
                            fieldErrors('form.userName'),
                            serverSideErrors('Username')
                          )
                        "
                        @blur="$v.form.userName.$touch()"
                        prepend-inner-icon="person"
                        solo
                        flat
                      ></v-text-field>

                      <v-text-field
                        :error-messages="
                          [].concat(
                            fieldErrors('form.email'),
                            serverSideErrors('Email')
                          )
                        "
                        @input="$v.form.email.$touch()"
                        @blur="$v.form.email.$touch()"
                        prepend-inner-icon="email"
                        v-model="form.email"
                        label="Email"
                        solo
                        flat
                      />
                      <v-text-field
                        :error-messages="
                          [].concat(
                            fieldErrors('form.password'),
                            serverSideErrors('Password')
                          )
                        "
                        :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPwd ? 'text' : 'password'"
                        @input="$v.form.password.$touch()"
                        @blur="$v.form.password.$touch()"
                        prepend-inner-icon="lock"
                        v-model="form.password"
                        label="Password"
                        @click:append="showPwd = !showPwd"
                        solo
                        flat
                      />
                      <v-text-field
                        type="password"
                        label="Confirm Password"
                        v-model="form.repeatPassword"
                        :error-messages="fieldErrors('form.repeatPassword')"
                        @input="$v.form.repeatPassword.$touch()"
                        @blur="$v.form.repeatPassword.$touch()"
                        prepend-inner-icon="enhanced_encryption"
                        required
                        solo
                        flat
                      ></v-text-field>

                      <h3>Personal Information</h3>
                      <hr />
                      <v-row class="mt-2">
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="form.firstName"
                            :error-messages="
                              [].concat(
                                fieldErrors('form.firstName'),
                                serverSideErrors('FirstName')
                              )
                            "
                            label="First Name"
                            @blur="$v.form.firstName.$touch()"
                            required
                            solo
                            flat
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="form.lastName"
                            @blur="$v.form.lastName.$touch()"
                            :error-messages="
                              [].concat(
                                fieldErrors('form.lastName'),
                                serverSideErrors('LastName')
                              )
                            "
                            label="Last Name"
                            required
                            solo
                            flat
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="form.phoneNumber"
                            v-mask="`(###) ###-####`"
                            :error-messages="
                              [].concat(
                                fieldErrors('form.phoneNumber'),
                                serverSideErrors('PhoneNumber')
                              )
                            "
                            @blur="$v.form.phoneNumber.$touch()"
                            label="Phone"
                            required
                            solo
                            flat
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="form.accountAddress"
                            :error-messages="
                              [].concat(
                                fieldErrors('form.accountAddress')
                              )
                            "
                            @blur="$v.form.accountAddress.$touch()"
                            label="Address"
                            required
                            solo
                            flat
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="form.accountAddress2"
                            :error-messages="
                              [].concat(
                                fieldErrors('form.accountAddress2')
                              )
                            "
                            @blur="$v.form.accountAddress2.$touch()"
                            label="Address 2"
                            required
                            solo
                            flat
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="form.accountCity"
                            :error-messages="
                              [].concat(
                                fieldErrors('form.accountCity'),
                                serverSideErrors('AccountCity')
                              )
                            "
                            @blur="$v.form.accountCity.$touch()"
                            label="City"
                            required
                            solo
                            flat
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <state-select 
                            v-model="form.accountState"
                            :error-messages="
                              [].concat(
                                fieldErrors('form.accountState'),
                                serverSideErrors('AccountState')
                              )
                            "
                            @blur="$v.form.accountState.$touch()"
                            label="State"
                            required
                            solo
                            flat
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="form.accountZipcode"
                            :error-messages="
                              [].concat(
                                fieldErrors('form.accountZipcode'),
                                serverSideErrors('accountZipcode')
                              )
                            "
                            @blur="$v.form.accountZipcode.$touch()"
                            label="Zipcode"
                            required
                            solo
                            flat
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row
                        ><v-col>
                          <div id="dropin-container"></div>
                        </v-col>
                      </v-row>
                      <v-checkbox
                        color="primary"
                        v-model="form.agreeToPolicy"
                        required
                      >
                        <div slot="label" @click.stop="() => {}">
                          Agree to
                          <v-btn-toggle
                            class="transparent blue--text"
                            @click.native.stop="showPrivacyPolicy = !showPrivacyPolicy"
                            >terms & privacy policy</v-btn-toggle
                          >.
                        </div>
                      </v-checkbox>
                      <v-btn
                        block
                        type="submit"
                        :loading="loading"
                        :disabled="$v.$invalid || !form.agreeToPolicy"
                        >Sign Up</v-btn
                      >
                      <div class="text-center my-5">
                        Already have account ?
                        <router-link
                          to="/pages/authentication/login"
                          class="py-1 no-text-decoration"
                          >Login</router-link
                        >
                      </div>
                    </v-form>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-card-text>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
    <PrivacyPolicyDialog :show="showPrivacyPolicy" @onClosed="showPrivacyPolicy=false"/>
  </v-sheet>
</template>

<script>
// Validations
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { mapActions, mapState } from "vuex";
import dropin from "braintree-web-drop-in";
import UTIL from "src/helpers/utility";
import AlertMessage from "src/components/AlertMessage";
import { isCombinationString, isAlphanumeric } from "src/utils/helpers";
import PrivacyPolicyDialog from "./_PrivacyPolicy";
import StateSelect from "components/StateSelect";
const validZip = (value) => /^\d{5}(?:[-\s]\d{4})?$/.test(value);

// const defaultForm = {
//   userName: "otan",
//   email: "otan@getnada.com",
//   password: "testinG123!",
//   agreeToPolicy: false,
//   nonce: "",
//   phoneNumber: "09019230",
//   firstName: "Didin",
//   lastName: "Ahmadi",
//   address: "Jl Beringin F15",
//   city: "Kuningan",
//   state: "Jawa Barat",
//   zipcode: "45561",
// };

const defaultForm = {
  userName: "",
  email: "",
  password: "",
  agreeToPolicy: false,
  nonce: "",
  phoneNumber: "",
  firstName: "",
  lastName: "",
  address: "",  
  city: "",
  state: "",
  zipcode: "",
};
export default {
  components: {
    AlertMessage,
    PrivacyPolicyDialog,
    StateSelect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      userName: { 
        required,
        valid: function (value) {
          return isAlphanumeric(value);
        }
      },
      email: { required, email },
      password: {
        required,
        minLength: minLength(8),
        valid: function (value) {
          return isCombinationString(value);
        },
      },
      repeatPassword: {
        required,
        sameAsPassword: sameAs("password"),
      },
      phoneNumber: {},
      firstName: { required },
      lastName: { required },
      accountAddress: { required },
      accountAddress2: {  },
      accountCity: { required },
      accountState: { required },
      accountZipcode: { required, validZip },
      agreeToPolicy: { required },
    },
  },
  validationMessages: {
    form: {
      userName: {
        valid: "Username cannot contain spaces or symbol",
        required: "User Name is required.",
      },
      email: {
        required: "Please enter email",
        email: "Email must be valid",
      },
      password: {
        required: "Please enter password",
        minLength: "Minimum length 8 characters",
        valid: "Needs at least one uppercase, one digit and one special character",
      },
      repeatPassword: {
        sameAsPassword: "Password does not match",
      },
      agreeToPolicy: {
        required: "You need to agree the term",
      },
      firstName:{
        required: "First Name is required"
      },
      lastName:{
        required: "Last Name is required"
      },
      accountAddress:{
        required: "Address is required"
      },
      accountAddress2:{
        required: "Address is required"
      },
      accountState:{
        required: "State is required"
      },
      accountCity:{
        required: "City is required"
      },
      accountZipcode: {
        required: "Zipcode is required",
        validZip: "Zipcode invalid"
      }
    },
  },
  data() {
    return {
      form: Object.assign({}, defaultForm),
      showPwd: false,
      error: false,
      dialog: false,
      loading: false,
      instance: null,
      showPrivacyPolicy:false      
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
  },

  mounted() {
    this.setupDropin();
  },
  methods: {
    ...mapActions("account", ["register"]),

    serverSideErrors(field) {
      return UTIL.gv(this.account.errors, field, []);
    },

    setupDropin() {
      console.log("Braintree Key:", process.env.VUE_APP_BRAINTREE_CLIENT_ID);
      dropin.create(
        {
          authorization: process.env.VUE_APP_BRAINTREE_CLIENT_ID,
          container: "#dropin-container",
          dataCollector: {
            kount: true, // Required if Kount fraud data collection is enabled
          },
        },
        (createErr, instance) => {
          if (createErr) {
            // Handle any errors that might've occurred when creating Drop-in
            console.error("error createErr", createErr);
            return;
          }
          this.instance = instance;
        }
      );
    },

    submit() {
      this.loading = true;
      this.$store.dispatch("alert/clear");

      // this.$errors.add({
      //   field: "email",
      //   msg: "YEYEYEYEY"
      // })

      this.instance.requestPaymentMethod(
        async (requestPaymentMethodErr, payload) => {
          if (requestPaymentMethodErr) {
            this.loading = false;
            return false;
          }
          this.form.nonce = payload.nonce;
          await this.register(this.form);
          if (!this.account.status.error) {
            this.resetForm();
          }
          this.loading = false;
        }
      );
    },

    resetForm() {
      this.form = Object.assign({}, defaultForm);
      // this.$refs.form.reset();
      this.$v.$reset();
    },
  },
};
</script>
